<template>
    <div v-if="isAuthorized">
        <v-main >
            <v-container fluid>
                <v-card id="titlecard" flat>
                    <v-row cols="12" dense>
                        <v-col cols="12">
                            <h2>{{ this.title }}</h2>
                        </v-col>
                    </v-row>
                    <v-row dense cols="12">
                        <v-col cols="2">
                            <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail/>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="1">
                            <div> 
                                <v-btn class="primary ma-6" x-small v-on:click="addTaak">Add new task</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <v-row class="row-default">
                    <v-col cols="12" class="px-2">
                        <v-data-table id="x" 
                            dense 
                            :headers="getTaakHeaders()" 
                            :items="taken" 
                            :items-per-page="15" 
                            :footer-props="{
                                'items-per-page-options': [10, 15, 50, 100, -1]
                            }"
                            item-key="taak" 
                            :loading="loading"
                            loading-text="Loading data...please wait" 
                            fixed-header 
                            :search="search"
                            :height="wInnerHeight">               
                            <template v-slot:item="taak">
                                <tr>
                                    <td class="td_markup">
                                        {{ taak.item.taak_code }}
                                    </td>
                                    <td class="td_markup">
                                        <longTextView :long_text="taak.item.taak_prog" :max_width="300"/>
                                    </td>
                                    <td class="td_markup">
                                        <longTextView :long_text="taak.item.taak_oms" :max_width="600"/>
                                    </td>
                                    <td class="td_markup">
                                        {{ taak.item.taak_used }}
                                    </td>
                                    <td class="td_markup">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" small>mdi-information-outline</v-icon>
                                            </template>
                                            <span v-html="taak.item.users"></span>
                                        </v-tooltip> 
                                    </td>
                                    <td class="td_markup">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn x-small text icon v-bind="attrs" v-on="on" v-on:click="editTaak(taak.item.taak_encrid)" class="mr-7 mb-2 gridbutton">
                                                    <v-icon small>mdi-wrench</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edit task</span>
                                        </v-tooltip> 
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn x-small text icon v-bind="attrs" v-on="on" v-on:click="editTaakUsers(taak.item)" class="mr-7 mb-2 gridbutton">
                                                    <v-icon small>mdi-account-multiple-plus-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edit task users</span>
                                        </v-tooltip> 
                                        <v-tooltip bottom v-if="taak.item.taak_used === 0">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn x-small text icon v-bind="attrs" v-on="on" v-on:click="rmTaak(taak.item.taak_encrid, taak.item.taak_code)" class="mr-7 mb-2 gridbutton">
                                                    <v-icon small>mdi-trash-can-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Remove task</span>
                                        </v-tooltip> 
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <addUpdTaak ref="addUpdTaak" @updateData="updateData"/>
        <rmTaak ref="rmTaak" @updateData="updateData"/>
        <updTaakUser ref="updTaakUser" @updateData="updateData"/>
        <div>
            <navBar :title="'Ares - Users'" :home="true" type="gebr"/>
        </div>
    </div>
</template>

<script>
    import mxauthorization from '@/mixins/authorization';

    import longTextView from "@/components/ui/fields/longTextView";
    import navBar from '@/components/ui/navbars/navbar.vue';
    import addUpdTaak from '@/views/syst/gebr/authorization/addUpdTaak.vue';
    import updTaakUser from '@/views/syst/gebr/authorization/updTaakUser.vue';
    import rmTaak from '@/views/syst/gebr/authorization/rmTaak.vue';

    export default {
        components: {
            longTextView,
            navBar,
            addUpdTaak,
            updTaakUser,
            rmTaak,
        },    
        mixins: [mxauthorization],
        data() {
            return {
                title: 'Task Maintenance',
                isAuthorized: false,
                taak_encrid: '',
                showUsers: false,
                search: '',
                taken: [],
                loading: false,
                wInnerHeight: window.innerHeight - 290, // deduct estimated height for toolbar, searchfield and headers
            }
        },    
        created() { // set up event bus listener here on created event or get data
            window.addEventListener("resize", this.resizeEventHandler);
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeEventHandler);
        },
        mounted() {
            this.getAuthorization("menu-users-authorizations", "isAuthorized");
        },
        watch:{
            isAuthorized(value) { 
                if (value) {
                    // Only get data if the user is authorized
                    this.getTaken();
                }           
            },
        }, 
        methods: {     
            updateData() {
                this.getTaken();
            },
            resizeEventHandler() {
                this.wInnerHeight = window.innerHeight - 290; // deduct estimated height for toolbar, searchfield and headers
            },
            getTaken() {
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/authorization/getTaak.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getTaak"
                    },
                    getTaak: {
                    }
                }).then(res => {
                    if (res.data.header.result == "error") {
                        console.log(res.data.error);
                    } else {
                        this.taken = res.data.getTaak;
                    }
                    this.loading = false;
                })
            },             
            getTaakHeaders() {
                return [
                    { text: "Task code", value: "taak_code", sortable: true, width: '15%' },
                    { text: "Task Programs", value: "taak_prog", sortable: true, width: '15%' },
                    { text: "Task Description", value: "taak_oms", sortable: true, width: '40%' },
                    { text: "# assigned users", value: "taak_used", sortable: false, width: '10%' },
                    { text: "users", value: "users", sortable: false, width: '10%' },
                    { text: "Actions", value: "", sortable: false, width: '10%' },
                ];
            },
            addTaak() {
                this.$refs.addUpdTaak.open("");
            },
            editTaak(taak_encrid) {
                this.$refs.addUpdTaak.open(taak_encrid);
            },
            editTaakUsers(taak) {
                this.$refs.updTaakUser.openSelect(taak);
            },
            rmTaak(taak_encrid, taak_code) {
                this.$refs.rmTaak.open(taak_encrid, taak_code);
            }
        }
    }
</script>

<style scoped> 
    .row-pointer {
        cursor: pointer;
    }

    .row-default {
        cursor: default;
    }

    .booking-color {
        color: blue;
    }
    .no-booking-color {
        color: black;
    }    
    .subtitle-weight{
        font-weight: 400;
    }
    .td_markup {
        vertical-align: top;
        border-top: 5px solid transparent !important;
        font-size: 12px !important;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }
    .td_markup_inner {
        vertical-align: top;
        /* border-top: 5px solid transparent; */
        border-top: 0px solid transparent !important;
        font-size: 12px !important;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }
    .td-code{
        width: 7.5em;
    }
    .td-name{
        width: 8em;
    }    
    .td-amount{
        width: 5em;
        text-align: end !important;
    }    
    .td-markup-xs {
        padding-top: 1px;
        padding-bottom: 2px;
        vertical-align: top;        
    }
    .border-xs{
        border-bottom: 1px solid lightgrey;
    }
</style>